/* eslint-disable prettier/prettier */
import { useGridApiRef } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import Table from "../../../../components/generic-table";
import { useUsers } from "../../../../hooks/users";
import { language } from "../../../../language";

const FETCH_STATE = {
  page: 0,
  pageSize: 10,
  sortBy: "id",
  sortOrder: "asc",
  searchTerm: "",
  checkeds: null,
  listOrganizationMembers: true,
};

// Component used in the modeler where redux cannot be used because it is not connected to the store
const UserSelectListPage = ({ selectedusers, onchangeUserSelect }) => {
  const apiRef = useGridApiRef();

  useEffect(() => {
    const users = selectedusers ? Object.keys(selectedusers) : [];
    const selecteds = { type: "include", ids: new Set(users) };
    apiRef.current.setRowSelectionModel(selecteds);
  }, [selectedusers]);

  const [pagination, setPagination] = useState(FETCH_STATE);
  const { data: userList } = useUsers({
    params: pagination,
  });

  const handleChange = (data) => {
    onchangeUserSelect(data);
  };

  const dataTable = {
    title: language.users,
    headers: [
      { title: language.id, field: "id" },
      { title: language.name, field: "name" },
      { title: language.email, field: "email" },
      { title: language.organization, field: "tenant" },
    ],
    actions: [],
    data: userList?.content?.length > 0 ? userList.content : [],
  };

  const dataPagination = {
    callData: setPagination,
    totalElements: userList?.totalElements,
    model: {
      ...pagination,
      count: userList?.size,
      sortHeader: FETCH_STATE.sortBy,
    },
    extraParameter: {
      listOrganizationMembers: true,
    },
  };

  // Verifying if the object has properties
  if (userList?.content && Object.keys(selectedusers).length > 0) {
    const keys = Object.keys(selectedusers);
    userList.content.forEach((element) => {
      // For each item in userList.content.id, we check if the key array exists
      if (keys.includes(element.id)) {
        // if userList.content.id is equal to a key, we change the value of the object
        // userList.content.tableData to checked true, so the item is selected
        // when the modal is opened and the table is loaded
        element.tableData = { id: element.id, checked: true };
      }
    });
  }

  return (
    <div>
      <Table
        apiRef={apiRef}
        tableData={dataTable}
        paginationMode="server"
        pagination={dataPagination}
        onRowSelectionModelChange={handleChange}
        checkboxSelection
      />
    </div>
  );
};

UserSelectListPage.propTypes = {
  selectedusers: PropTypes.object.isRequired,
  onchangeUserSelect: PropTypes.func.isRequired,
};

export default UserSelectListPage;
